<template>
  <div>
    <!-- role="list": the tiles are a set, and the list item then gives each generic
         "Start"/"Continue" button its context (WCAG SC 2.4.4, audit 31.1). -->
    <div class="vx-row" role="list">
      <div
        class="vx-col w-full sm:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full mb-base"
        role="listitem"
        v-for="(item, index) in activities"
        :key="item.id"
      >
        <vx-card :custom-classes="['h-100']">
          <div slot="no-body" class="project_img_wrapper">
            <img
              :src="
                ('content/' +
                  experience.vje.folder_name.toLowerCase() +
                  '/activity_tiles/activity_' +
                  (index + 1) +
                  '.jpg')
                  | blob_url
              "
              role="presentation"
              class="responsive card-img-top"
              alt=""
            />
          </div>
          <div class="mb-auto">
            <heading size="h3" style-size="h5" class="project_title">{{ item.title }}</heading>
            <p class="project_description my-4"><span v-html="item.description"></span></p>
            <p class="project_info mb-1"><strong>Level:</strong> {{ item.level }}</p>
            <p class="project_info"><strong>Approx. Time:</strong> {{ item.approx_time }}</p>
          </div>
          <div class="flex justify-between flex-wrap mt-5">
            <button
              class="btn btn-secondary btn-size-small"
              :aria-label="`View Details: ${item.title}`"
              @click="showPopup(item.id)"
            >
              View Details
            </button>
            <template>
              <!-- The visible text stays first in the name (SC 2.5.3 Label in Name). -->
              <button
                class="btn btn-primary btn-size-small"
                role="link"
                :aria-label="`${buttonTitle(item)}: ${item.title}`"
                @click="navigateToActivity(item.slug)"
              >
                {{ buttonTitle(item) }}
              </button>
            </template>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-popup title="Project Description" :active.sync="popupActive">
      <p><span v-html="popupContent"></span></p>
    </vs-popup>
  </div>
</template>

<script>
import store from '@/store/store';
import theApi from '@/mixins/theApi';

export default {
  data() {
    return {
      popupActive: false,
      popupContent: '',
      loginType: localStorage.getItem('login_type'),
      activityBaseUrl:
        localStorage.getItem('login_type') === 'student'
          ? '/student/work-experience/' + this.$route.params.id + '/activities/'
          : '/teacher/vje/experience/view/' + this.$route.params.id + '/activities/',
    };
  },
  computed: {
    experience() {
      if (this.loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    activities() {
      //Show only public activitiies
      const activities = this.experience.activities.filter(function (item) {
        return item.is_public !== 0;
      });
      const student_activities = this.experience.student_activities;
      activities.forEach((activity) => {
        const foundStudentActivity = student_activities.find((i) => i.activity_id == activity.id);
        if (foundStudentActivity) {
          activity.completed = foundStudentActivity.completed;
        } else {
          activity.completed = false;
        }
      });
      return activities;
    },
    isEditable() {
      if (this.experience && this.experience.active) return true;
      return false;
    },
  },
  methods: {
    showPopup(activityID) {
      const activity = this.activities.find((p) => p.id === activityID);
      if (activity) {
        this.popupContent = activity.intro;
        this.popupActive = true;
      }
    },
    async saveActivity(activity_id, data) {
      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);
      formData.append('activity_id', activity_id);
      formData.append('data', data);
      formData.append('file', -1);
      formData.append('completed', 0);
      formData.append('start', true);

      theApi.methods
        .makeCall(false, 'experiences/activities/save', 'post', formData, null, true)
        .then((data) => {
          if (data.status == 'OK') {
            //Update Vuex activity
            const activity_data = {
              student_vje_id: this.$route.params.id,
              activity_id: activity_id,
              data: data.activity,
            };

            store.commit('authStudent/updateExperienceActivity', activity_data);
            if (typeof data.file !== 'undefined') {
              this.uploaded_file = data.file;
            }
            if (typeof data.vje_is_active !== 'undefined' && !data.vje_is_active) {
              const experience_data = {
                id: this.$route.params.id,
                data: {
                  activities_completed: 1,
                },
              };
              store.commit('authStudent/modifyExperience', experience_data);
            }
          }
        });
    },
    navigateToActivity(slug) {
      this.$router.push(this.activityBaseUrl + slug);

      const { id } = this.activities.find((activity) => activity.slug === slug);
      const existed = this.experience.student_activities.find(
        (activity) => activity.activity_id === id,
      );

      if (!existed) {
        this.saveActivity(slug, null);
      }
    },
    buttonTitle(item) {
      if (item.completed && item.completed !== '0') {
        return 'View activity';
      } else if (!this.isEditable) {
        return 'Not completed';
      } else {
        let existed = this.experience.student_activities.find(
          (activity) => activity.activity_id === item.id,
        );
        return existed ? 'Continue' : 'Start';
      }
    },
  },
  mounted() {
    if (this.activities.length === 1) {
      this.navigateToActivity(this.activities[0].slug);
    }
  },
};
</script>

<style scoped lang="scss">
.project_img_wrapper {
  height: 250px;
  overflow: hidden;
}
.project_img_wrapper img {
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
}
.project_description {
  height: 3.2em;
  overflow: hidden;
  line-height: 1.6em;
}
.project_title {
  height: 2.4em;
  overflow: hidden;
  line-height: 1.3em;
}
::v-deep {
  .vx-card .vx-card__collapsible-content.vs-con-loading__container {
    height: 100%;
  }
  .vx-card__body {
    display: flex;
    flex-direction: column;
    height: calc(100% - 250px);
  }
}
@media screen and (min-width: 1200px) and (max-width: 1440px) {
  .project_img_wrapper {
    height: 200px;
  }
  ::v-deep {
    .vx-card__body {
      height: calc(100% - 200px);
    }
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .project_img_wrapper {
    height: 200px;
  }
  ::v-deep {
    .vx-card__body {
      height: calc(100% - 200px);
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1440px) {
  .project_img_wrapper {
    height: 200px;
  }
  ::v-deep {
    .vx-card__body {
      height: calc(100% - 200px);
    }
  }
}
@media screen and (max-width: 768px) {
  .project_img_wrapper {
    height: 230px;
  }
  ::v-deep {
    .vx-card__body {
      height: calc(100% - 230px);
    }
  }
}
</style>
